var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDeleteHoverRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#C4314B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 9.66672L9.66662 11L13.6665 15L9.66653 19L10.9999 20.3333L14.9999 16.3333L18.9999 20.3334L20.3333 19L16.3332 15L20.3332 11L18.9999 9.66663L14.9999 13.6666L11 9.66672Z",
    fill: "#FCF4F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteHoverRed);
export default __webpack_public_path__ + "static/media/Icon_DeleteHover_Red.46fb9ab2ab17bcea0aceb79c0289402b.svg";
export { ForwardRef as ReactComponent };